import React, { useRef } from "react";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import "./SearchInput.scss";
import Buttons from "../Buttons/Buttons";

// Drop-in replacement for the hand-rolled "<input> + IoIosSearch" search
// boxes used across the app. Keeps the caller's own wrapper class (for
// page-specific width/position) and adds a clear (x) button, shown only
// once there's a value, so search-input styling stays consistent everywhere.
const SearchInput = ({
  value,
  onChange,
  placeholder = "Search",
  name,
  className,
}) => {
  const inputRef = useRef(null);

  const handleClear = () => {
    onChange({ target: { name, value: "" } });
    inputRef.current?.focus();
  };

  return (
    <div className={`search-input${className ? ` ${className}` : ""}`}>
      <input
        ref={inputRef}
        type="text"
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
      />
      <SearchIcon className="searchicon" />
      {value && (
        <Buttons
          icon={<CloseIcon />}
          ariaLabel="Clear search"
          onClick={handleClear}
          style={{
            position: "absolute",
            top: "50%",
            right: 8,
            transform: "translateY(-50%)",
            width: 18,
            height: 18,
            padding: 0,
            color: "#6b6b6b",
            fontSize: 16,
          }}
        />
      )}
    </div>
  );
};

export default SearchInput;
